
interface VideoEmbedProps {
  url: string;
  type: 'youtube' | 'vimeo' | '';
  title?: string;
}

export default function VideoEmbed({ url, type, title = '動画' }: VideoEmbedProps) {
  if (!url || !type) return null;

  return (
    <div className="my-8">
      <div className="relative w-full pt-[56.25%] bg-gray-900 rounded-lg overflow-hidden shadow-lg">
        <iframe
          src={url}
          title={title}
          className="absolute inset-0 w-full h-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
      <p className="text-center text-gray-500 text-sm mt-3">
        <i className="ri-play-circle-line mr-1"></i>
        {type === 'youtube' ? 'YouTube' : 'Vimeo'}で視聴
      </p>
    </div>
  );
}
